__turbopack_context__.v({
  "checkBoxContainer": "checkbox-module-scss-module__XreJca__checkBoxContainer",
  "checkmark": "checkbox-module-scss-module__XreJca__checkmark",
  "labelText": "checkbox-module-scss-module__XreJca__labelText",
});
